import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import { Button, useCreatePath } from 'react-admin';
import { Link } from 'react-router-dom';

export const DuplicateButton = ({
    label,
    resource,
    duplicateDefaults,
}: {
    label: string;
    resource: string;
    duplicateDefaults: any;
}) => {
    const createPath = useCreatePath();

    return (
        <Button
            component={Link}
            to={createPath({ type: 'create', resource })}
            state={{
                duplicateDefaults,
            }}
            startIcon={<ControlPointDuplicateIcon />}
            size="small"
            label={label}
        />
    );
};
